/* eslint-disable jsx-a11y/no-autofocus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SearchField extends Component {
    componentDidMount() {
        this.textInput.focus();
    }

    render() {
        return (
            <div className="search-header">
                <form onSubmit={(event) => { event.preventDefault(); this.props.handleSearch(); }}>
                    <div className="search-input">
                        <label className="search-input__query" htmlFor="query">
                            <span className="visually-hidden">zoekterm?</span>
                            <input
                                className="search-input__input"
                                name="query"
                                id="query"
                                type="search"
                                value={this.props.query}
                                placeholder="Zoeken"
                                onChange={(event) => { this.props.handleUpdateQuery(event.target.value); }} // eslint-disable-line max-len
                                ref={(input) => { this.textInput = input; }}
                            />
                        </label>

                        <button className="search-input__button button button--search" type="submit">Zoeken</button>
                    </div>
                </form>
                <div className="search-description">Geef een zoekterm in. Plaats telkens 'AND' tussen meerdere zoektermen.</div>
            </div>
        );
    }
}


SearchField.propTypes = {
    query: PropTypes.string.isRequired,
    handleUpdateQuery: PropTypes.func.isRequired,
    handleSearch: PropTypes.func.isRequired,
};

export default SearchField;
